import React from 'react';
import Header from '../componentes/Header';
import productosPaneles from '../data/todosLosProductos/panelesDecorativos';
import { NavLink, Link, useNavigate } from 'react-router';
import AnimacionPagina from '../componentes/AnimacionPagina';
import { motion } from 'framer-motion';

import SectionProductos from '../elementos/SectionProductos';
import ContainerProductos from '../elementos/ContaninerProductos';
import ProductoContainer from '../elementos/ProductoContainer';
import BtnVolverAnim from '../elementos/BtnVolverAnim';
import { Helmet } from 'react-helmet';
import Footer from '../componentes/Footer';

const PanelesDecorativos = () => {
        const navigate = useNavigate();
    return ( 
        <>
        <Helmet>
            <title>Pertina | Hi Blinds</title>
            <meta name="description" content="Paneles Decorativos elegantes. Calidad textil con más de 50 años de experiencia." />
            <meta property="og:title" content="Paneles Decorativos | Hi Blinds" />
            <meta property="og:description" content="Explora nuestros paneles decorativos mármol, piedra y media luna." />
            <meta property="og:url" content="https://hiblindsmx.com/paneles-decorativos" />
        </Helmet>

            <Header />
            <AnimacionPagina>
                <SectionProductos>

                <h1>Paneles Decorativos</h1>
                <BtnVolverAnim Ref='/'/>
                <ContainerProductos>
                    {productosPaneles.map((producto, index) =>  {
                     const { imagenDemostracion } = procesarProducto(producto);

                     return (
                        <motion.div
                        key={producto.id}
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.4, delay: index * 0.1 }}
                        >
                            <ProductoContainer 
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.8 }}
                            key={producto.id}
                            onClick={() => {
                            navigate(`/paneles-decorativos/${producto.slug}`);
                                }}
                            style={{ cursor: 'pointer' }}>
                                <img 
                                loading='lazy' 
                                src={imagenDemostracion} 
                                alt={`${producto.nombre}`} 
                                />
                                <h4>{producto.nombre}</h4>
                                <p>Ancho de tela: {producto.anchoTela}</p>
                                <Link to={`/paneles-decorativos/${producto.slug}`}>
                                <button type='button'>Más información</button>
                               </Link>
                            </ProductoContainer>
                        </motion.div>
                     );
                 })}
                </ContainerProductos>
               
                <BtnVolverAnim Ref='/'/>
                </SectionProductos>
                <Footer />
            </AnimacionPagina>
            
        </>
     );
}
const procesarProducto = (producto) => {
    const imagenDemostracion = producto.images[0];
    const imagenesColores = producto.images.slice(1).map((imagen, index) => ({
        color: producto.colores[index],
        imagen
    }));
    return { imagenDemostracion, imagenesColores };
};




export default PanelesDecorativos;